<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">地域詳細</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="save" v-permit.SHARP_COUNTRY_NEW>{{
          $t("app.buttons.save")
        }}</v-btn>
        <v-btn @click="$router.go(-1)">{{ $t("app.buttons.back") }}</v-btn>
      </v-card-actions>
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout wrap>
            <v-flex md3 sm6 xs6>
              <div required>
                <v-text-field
                  :disabled="$route.path.indexOf('new') === -1"
                  :rules="[(v) => !!v || ` ISO地CD is required`]"
                  clearable
                  label="ISO地CD"
                  v-model.trim="form.code"
                ></v-text-field>
              </div>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex md3 sm6 xs6>
              <v-text-field
                clearable
                label="SC側CD"
                v-model="form.scCode"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex md3 sm6 xs6>
              <v-text-field
                clearable
                label="名称"
                v-model="form.name"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex md3 sm6 xs6>
              <v-text-field
                clearable
                label="英語名称"
                v-model="form.englishName"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>
<script>
/* eslint-disable no-console */
export default {
  data() {
    return {
      valid: true,
      form: {
        code: "",
        scCode: "",
        name: "",
        englishName: "",
      },
    };
  },
  methods: {
    save() {
      this.$http
        .post("/countries", this.form)
        .then(() => {
          this.$router.go(-1);
        })
        .catch((res) => {
          this.$message(
            this.$t("app.messages.errors.title"),
            res.response.data.message
          );
        });
    },
  },
  mounted() {
    this.root = { ...this.$route.params };
  },
};
</script>
